/*eslint-disable no-undef*/
import React, { Component } from 'react';

class Page2 extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount(){
    window.deeploop.page("Page 2");
  }

  render() {
    return (
      <div>
          This is page #2
      </div>
    )
  }
}

export default Page2;


// WEBPACK FOOTER //
// ./src/components/Page2.jsx